// Filename: uiarticleprev.js
// Timestamp: 2017.11.19-13:41:57 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

// awkward canvas when container is resized to proportions
// different from those used on initial canvas 'render'
//
// canvas kept inside container w/ overflow:hidden
// canvas resized to 'fit' container on resize
const xvnode = (ss, cfg, gr, nd, pg, subj) => {
  const { a, ul, li, p, div, h3, h2, span, article } = cfg.h(pg, nd)
  const {
    title,
    author,
    href,
    posterimg,
    excerptnohtml,
    datepublished
  } = subj
  const isexce = Boolean(excerptnohtml)
  const isfeat = Boolean(subj.isfeature)
  const h2ORh3 = isfeat ? h2 : h3

  return (
    article(`#:key.:ui-root.st-isexcerpt-${isexce}.st-isfeature-${isfeat}`, [
      div('.:ui-details', [
        h2ORh3('.:ui-details-title', [
          a('.:ui-details-title-link', {
            href,
            title: excerptnohtml || title
          }, title)
        ]),
        ul('.:ui-details-list', [
          li('.:ui-details-listitem', [
            span('.:ui-details-listitem-author', author)
          ]),
          li('.:ui-details-listitem', [
            span('.:ui-details-listitem-published-date', datepublished)
          ])
        ])
      ]),

      a('.:ui-poster', {
        href,
        title: excerptnohtml || title,
        style: posterimg ? {
          'background-image': `url('${posterimg}')`
        } : {}
      }),

      isfeat && (
        div('.:ui-excerpt', [
          p('.:ui-excerpt-p', [
            span(excerptnohtml + ' '),
            a('.:ui-excerpt-morelink', {
              href,
              title
            }, 'Read more …')
          ])
        ])
      )
    ])
  )
}

export default {
  type: 'uiarticleprev',
  xvnode
}
